module.exports = __webpack_public_path__ + "img/user.8e7736f2.svg";